import { Snackbar, Typography } from "@mui/material";
import React from "react";
import MuiAlert from "@mui/material/Alert";

interface ErrorHandlerProps {
  open: boolean;
  onClose: () => void;
  errorMessage: string;
  errorCode: string;
}

const ErrorHandler: React.FC<ErrorHandlerProps> = ({
  open,
  onClose,
  errorMessage,
  errorCode,
}) => {
  const alertMessage = (() => {
    switch (errorCode) {
      case "ENETWORK":
      case "ERR_NETWORK":
        return "・Please verify your internet connection.\n・If the issue persists, contact our support team for assistance.";
      case "ECONNABORTED":
        return "・The request could not be completed within the specified time.\n・Please try again later.";
      default:
        return "・Please try again later.\n・If the issue persists, contact our support team for assistance.";
    }
  })();

  const handleClose = () => {
    onClose();
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <MuiAlert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
        <Typography variant="h6">An Unexpected Error Has Occurred</Typography>
        <Typography variant="body2">
          {errorMessage}
        </Typography>
        <Typography variant="body2" style={{ whiteSpace: "pre-line" }}>
          {alertMessage}
        </Typography>
      </MuiAlert>
    </Snackbar>
  );
};

export default ErrorHandler;
